module.exports = __webpack_public_path__ + "img/experts.41713c3.png";